(function () {
  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  function makeSplide(el) {
    if (el.dataset.dgtMounted === '1') return null;
    // NOTE: previously bailed on mobile (intending a native CSS scroll), but the CSS to
    // reveal the cards was never added, so Splide's pre-init `visibility:hidden` was
    // never lifted and the whole carousel was invisible on phones. Mount on mobile too
    // (one card per view) so Splide manages visibility + layout.
    if (!window.Splide) return null;
    el.dataset.dgtMounted = '1';
    var splide = new Splide(el, {
      perPage: 3,
      gap: '20px',
      arrows: true,
      pagination: false,
      drag: 'free',
      snap: true,
      flickPower: 300,
      flickMaxPages: 1,
      speed: 500,
      breakpoints: {
        1100: { perPage: 2 },
        749: { perPage: 1, gap: '12px', arrows: true, pagination: true }
      }
    });
    splide.mount();
    return splide;
  }

  function tabs(root, instances) {
    var tabEls = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-panel]');
    tabEls.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = tab.dataset.tab;
        tabEls.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.panel === i);
        });
        var el = root.querySelector('[data-panel="' + i + '"] [data-collection-splide]');
        if (el) {
          if (!instances[i]) instances[i] = makeSplide(el);
          else instances[i].refresh();
        }
      });
    });
  }

  function buyboxes(root) {
    root.querySelectorAll('.dgt-card-buybox').forEach(function (form) {
      var spInput = form.querySelector('[data-selling-plan]');
      if (!spInput) return;
      var freq = form.querySelector('[data-freq]');
      var freqWrap = form.querySelector('[data-freq-wrap]');
      var radios = form.querySelectorAll('[data-mode]');
      var card = form.closest('.dgt-card');
      // qty-pack cards are driven by qtyPackCards() instead.
      if (card && card.querySelector('[data-card-packqty]')) return;
      var priceEl = card ? card.querySelector('[data-card-price]') : null;
      var dataEl = card ? card.querySelector('[data-card-variants]') : null;
      var vmap = {};
      if (dataEl) { try { vmap = JSON.parse(dataEl.textContent); } catch (e) {} }

      function activeVariant() {
        if (!card) return null;
        var swatches = card.querySelectorAll('[data-card-flavor]');
        var packs = card.querySelectorAll('[data-card-pack]');
        var flavor = '', pack = '';
        for (var i = 0; i < swatches.length; i++) { if (swatches[i].classList.contains('is-active')) { flavor = swatches[i].getAttribute('data-flavor'); break; } }
        if (!flavor && swatches.length) flavor = swatches[0].getAttribute('data-flavor');
        // Single-flavor product (no swatches): use the sole variant key's flavor.
        if (!flavor && !swatches.length) { var fk = Object.keys(vmap); if (fk.length) flavor = fk[0].split('|')[0]; }
        for (var j = 0; j < packs.length; j++) { if (packs[j].classList.contains('is-active')) { pack = packs[j].getAttribute('data-pack'); break; } }
        if (!pack && packs.length) pack = packs[0].getAttribute('data-pack');
        return vmap[flavor + '|' + pack] || null;
      }

      function apply() {
        var sub = form.querySelector('[data-mode="sub"]');
        var isSub = sub && sub.checked;
        if (isSub) {
          spInput.disabled = false;
          spInput.value = freq ? freq.value : '';
          if (freqWrap) freqWrap.hidden = false;
        } else {
          spInput.disabled = true;
          spInput.value = '';
          if (freqWrap) freqWrap.hidden = true;
        }
        form.querySelectorAll('.dgt-card-buybox__mode').forEach(function (m) {
          var r = m.querySelector('input');
          m.classList.toggle('is-active', r && r.checked);
        });
        if (priceEl) {
          var v = activeVariant();
          if (v) priceEl.textContent = (isSub && v.subPrice) ? v.subPrice : v.price;
          var wasEl = card ? card.querySelector('[data-card-price-was]') : null;
          if (wasEl) {
            if (isSub && v && v.subPrice && v.subPrice !== v.price) { wasEl.textContent = v.price; wasEl.hidden = false; }
            else wasEl.hidden = true;
          }
        }
      }
      radios.forEach(function (r) { r.addEventListener('change', apply); });
      if (freq) freq.addEventListener('change', apply);
      apply();
    });
  }

  function cardFlavors(root) {
    root.querySelectorAll('.dgt-card').forEach(function (card) {
      // qty-pack cards are driven by qtyPackCards() instead.
      if (card.querySelector('[data-card-packqty]')) return;
      var swatches = card.querySelectorAll('[data-card-flavor]');
      var packs = card.querySelectorAll('[data-card-pack]');
      if (!swatches.length && !packs.length) return;
      var img = card.querySelector('.dgt-card__img');
      var variantInput = card.querySelector('[name="id"]');
      var priceEl = card.querySelector('[data-card-price]');
      var dataEl = card.querySelector('[data-card-variants]');
      var vmap = {};
      if (dataEl) { try { vmap = JSON.parse(dataEl.textContent); } catch (e) {} }

      function activeAttr(list, attr) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].classList.contains('is-active')) return list[i].getAttribute(attr);
        }
        return list.length ? list[0].getAttribute(attr) : '';
      }
      function isSub() {
        var subRadio = card.querySelector('[data-mode="sub"]');
        return subRadio && subRadio.checked;
      }
      function sync() {
        var flavor = swatches.length ? activeAttr(swatches, 'data-flavor') : '';
        var pack = packs.length ? activeAttr(packs, 'data-pack') : '';
        var v = vmap[flavor + '|' + pack];
        if (v) {
          if (variantInput) variantInput.value = v.id;
          if (priceEl) priceEl.textContent = (isSub() && v.subPrice) ? v.subPrice : v.price;
        }
      }
      function applySwatchColors(sw) {
        if (sw.dataset.primary) card.style.setProperty('--card-primary', sw.dataset.primary);
        if (sw.dataset.secondary) card.style.setProperty('--card-secondary', sw.dataset.secondary);
      }
      var activeSwatch = card.querySelector('[data-card-flavor].is-active') || swatches[0];
      if (activeSwatch) applySwatchColors(activeSwatch);

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.toggle('is-active', s === sw); });
          if (img && sw.dataset.image) img.src = sw.dataset.image;
          applySwatchColors(sw);
          sync();
        });
      });
      packs.forEach(function (pk) {
        pk.addEventListener('click', function () {
          packs.forEach(function (p) { p.classList.toggle('is-active', p === pk); });
          var flavor = swatches.length ? activeAttr(swatches, 'data-flavor') : '';
          var pack = pk.getAttribute('data-pack');
          var v = vmap[flavor + '|' + pack];
          if (v && img && v.image) img.src = v.image;
          sync();
        });
      });
      sync();
    });
  }

  // Cards for qty-packs products: PDP-style 1/2/3-Pack tiles that set quantity,
  // the _pack_size line property, and (when Subscribe is on) the matching pack plan.
  function qtyPackCards(root) {
    root.querySelectorAll('.dgt-card').forEach(function (card) {
      var tiles = card.querySelectorAll('[data-card-packqty]');
      if (!tiles.length) return;
      var form = card.querySelector('.dgt-card-buybox');
      if (!form) return;
      var spInput = form.querySelector('[data-selling-plan]');
      var qtyInput = form.querySelector('[data-card-qty]');
      var packSizeInput = form.querySelector('[data-card-packsize]');
      var idInput = form.querySelector('[name="id"]');
      var priceEl = card.querySelector('[data-card-price]');
      var img = card.querySelector('.dgt-card__img');
      var swatches = card.querySelectorAll('[data-card-flavor]');
      var dataEl = card.querySelector('[data-card-variants]');
      var vmap = {};
      if (dataEl) { try { vmap = JSON.parse(dataEl.textContent); } catch (e) {} }
      var userPickedPack = false;

      function activeFlavor() {
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i].classList.contains('is-active')) return swatches[i].getAttribute('data-flavor');
        }
        if (swatches.length) return swatches[0].getAttribute('data-flavor');
        // Single-flavor product (no swatches): fall back to the sole variant key's flavor
        // so currentVariant() resolves instead of looking up a non-existent empty "|" key.
        var keys = Object.keys(vmap);
        return keys.length ? keys[0].split('|')[0] : '';
      }
      function currentVariant() { return vmap[activeFlavor() + '|'] || null; }
      function selectedN() {
        for (var i = 0; i < tiles.length; i++) {
          if (tiles[i].classList.contains('is-active')) return parseInt(tiles[i].getAttribute('data-card-packqty'), 10) || 1;
        }
        return 1;
      }
      function isSub() { var s = form.querySelector('[data-mode="sub"]'); return s && s.checked; }
      function applyPackImage() {
        if (!img) return;
        var v = currentVariant();
        if (!v) return;
        var n = selectedN();
        // Always show the pack photo — including the 1-pack on first load — so the CARD reflects
        // the clean pack pouch even when the variant image is a different product-page hero
        // (e.g. the herbal ribbon versions). Falls back to the rendered variant image if a flavor
        // has no pack_images.
        var pi = v.packImages;
        if (pi && pi[String(n)]) img.src = pi[String(n)];
      }

      function repriceTiles() {
        var v = currentVariant();
        if (!v || !v.t) return;
        var sub = isSub();
        tiles.forEach(function (tl) {
          var n = parseInt(tl.getAttribute('data-card-packqty'), 10);
          var pe = tl.querySelector('[data-tier-price]');
          if (pe && v.t[n]) pe.textContent = (sub && v.t[n].sub) ? v.t[n].sub : v.t[n].ot;
        });
      }
      var wasEl = card.querySelector('[data-card-price-was]');
      function update() {
        var v = currentVariant();
        if (!v) return;
        var n = selectedN();
        var t = (v.t && v.t[n]) ? v.t[n] : null;
        if (idInput) idInput.value = v.id;
        if (qtyInput) qtyInput.value = n;
        if (packSizeInput) packSizeInput.value = n;
        var sub = isSub();
        if (sub && t && t.plan) {
          if (spInput) { spInput.disabled = false; spInput.value = t.plan; }
          if (priceEl && t.sub) priceEl.textContent = t.sub;
          // Show the one-time price struck through (like the PDP buy box).
          if (wasEl && t.sub && t.ot && t.sub !== t.ot) { wasEl.textContent = t.ot; wasEl.hidden = false; }
          else if (wasEl) wasEl.hidden = true;
        } else {
          if (spInput) { spInput.disabled = true; spInput.value = ''; }
          if (priceEl && t) priceEl.textContent = t.ot;
          if (wasEl) wasEl.hidden = true;
        }
        form.querySelectorAll('.dgt-card-buybox__mode').forEach(function (m) {
          var r = m.querySelector('input');
          m.classList.toggle('is-active', r && r.checked);
        });
        repriceTiles();
        applyPackImage();
      }

      tiles.forEach(function (tl) {
        tl.addEventListener('click', function () {
          tiles.forEach(function (x) { x.classList.toggle('is-active', x === tl); });
          userPickedPack = true;
          update();
        });
      });
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.toggle('is-active', s === sw); });
          if (img && sw.dataset.image) img.src = sw.dataset.image;
          if (sw.dataset.primary) card.style.setProperty('--card-primary', sw.dataset.primary);
          if (sw.dataset.secondary) card.style.setProperty('--card-secondary', sw.dataset.secondary);
          repriceTiles();
          update();
        });
      });
      form.querySelectorAll('[data-mode]').forEach(function (r) { r.addEventListener('change', update); });
      repriceTiles();
      update();
    });
  }

  function init(root) {
    if (root.dataset.dgtCollectionReady === '1') return;
    root.dataset.dgtCollectionReady = '1';
    var instances = {};
    function mountActive() {
      var active = root.querySelector('[data-panel].is-active') || root.querySelector('[data-panel]');
      if (active) {
        var el = active.querySelector('[data-collection-splide]');
        if (el) instances[active.dataset.panel] = makeSplide(el);
      }
    }
    // Always wait for Splide (mobile included now) before mounting the active panel.
    whenSplideReady(mountActive);
    tabs(root, instances);
    buyboxes(root);
    cardFlavors(root);
    qtyPackCards(root);
  }

  function whenSplideReady(cb) {
    if (window.Splide) { cb(); return; }
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (window.Splide) { clearInterval(timer); cb(); }
      else if (tries > 100) { clearInterval(timer); }
    }, 50);
    window.addEventListener('load', function () { if (window.Splide) { clearInterval(timer); cb(); } });
  }

  function boot() {
    document.querySelectorAll('[data-dgt-collection-root]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-dgt-collection-root]');
    if (root) init(root);
  });
})();
